import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import PageTitle from '../../atoms/PageTitle';
import { useSelector } from 'react-redux';
import ListWithCheckIcon from '../../atoms/ListWithCheckIcon';
import Button from '../../atoms/Button';
import BookingFormSummary from '../../atoms/BookingFormSummary';
import { useNavigate } from 'react-router-dom';
import { URLS } from '../../../utils/urls';
import { transFormWon } from '../../../utils/numbers';
import moment from 'moment';
import { utf8ToBase64 } from '../../../lib/Util';
import { getValueByTarget } from '../../../utils/parse';
import { UsageTimeOptions, UsageTimeOptionsAnnual, UsageTimeOptionsMonthly } from '../../../utils/EstimateFormData';

/**
 * 계약 완료 페이지
 * name : completeContract
 * */
const CompleteContract = () => {
  const navigate = useNavigate();
  const { BookingOption } = useSelector((state) => state);
  const [description, setDescription] = useState([])
  const [ojtLink, setOjtLink] = useState('')
  


  useEffect(() => {
    let CompleteContractDescription = [
      '월간 모시러 계약이 완료 되었습니다.',
      '날인 해주신 계약서는 담당자님 메일로 발송이 되었습니다.',
    ]
    
    if (BookingOption?.userInformation?.paymentType == '카드') {
      /*
      CompleteContractDescription.push(`입금 금액은 <i class='blue txt-large'>${transFormWon(BookingOption?.totalAmount)}</i> 입니다. <br>
       카카오 알림톡 및 청구 메일 내 카드결제 링크가 있으므로, 해당 링크를 통해 카드 등록 및 결제를 진행해주세요.<br>
       결제 기한: <i class='blue txt-large'>${moment(BookingOption?.userInformation?.purchaseDate).format('yyyy년 MM월 DD일')} 오후 3시</i>`,)
      */
      CompleteContractDescription.push(`입금 금액은 <i class='blue txt-large'>${transFormWon(BookingOption?.totalAmount)}</i> 입니다. <br>
       카드결제는 모시러 컨시어지로 연락해주세요.<br>
       결제 기한: <i class='blue txt-large'>${moment(BookingOption?.userInformation?.purchaseDate).format('yyyy년 MM월 DD일')} 오후 3시</i>`,)
    }
    // 현금영수증 or 세금계산서
    else {
      CompleteContractDescription.push(`입금 금액은 <i class='blue txt-large'>${transFormWon(BookingOption?.totalAmount)}</i> 이며 <br>
       입금 계좌는 (주)버틀러 신한은행 140-011-170175 입니다. <br>
       결제 기한: <i class='blue txt-large'>${moment(BookingOption?.userInformation?.purchaseDate).format('yyyy년 MM월 DD일')} 오후 3시</i>`,)
    }

    CompleteContractDescription.push('결제가 확인 되면 예약 계정을 생성해 드립니다.')
    CompleteContractDescription.push(`<a href='${URLS.BOOKING_ESTIMATION_SUBSCRIPTION}' class='txt-large underline' target='_blank'>첫 화면으로 이동</a>`)

    const isMonthly = (BookingOption?.subscription == 'monthly') ? true : false
   
    // Encode
    const tempInfoEnc = encodeURIComponent(utf8ToBase64(JSON.stringify({ 
      CustomerName: BookingOption?.userInformation?.user?.name, 
      PhoneNumber: BookingOption?.userInformation?.phoneNumber, 
      EmailAddress: BookingOption?.userInformation?.emailAddress, 
      ProductType: isMonthly ? 1 : 2, 
      ProductDay: getValueByTarget(isMonthly ? UsageTimeOptionsMonthly : UsageTimeOptionsAnnual,BookingOption.usageTime,'estimateDay'), 
      ProductHour: getValueByTarget(isMonthly ? UsageTimeOptionsMonthly : UsageTimeOptionsAnnual,BookingOption.usageTime,'estimateHour') 
    })))

    setOjtLink(`https://common.mosiler.com/ojt_external/index.html?info=${tempInfoEnc}`)



    // 입금 완료 후 OJT 발송 시점에 어느 Table에서든 qs 데이터를 받아와야한다.


    setDescription(CompleteContractDescription)
  }, [BookingOption])

  return (
    <>
      {description && (
        <div className={classNames('booking-wrap')}>
          <PageTitle title={'계약 완료'} subtitle={'계약이 완료되었습니다'} />
          <div className={classNames('confirm-booking-wrap')}>
            <div className={classNames('confirm-booking-content')}>
              <ListWithCheckIcon listItem={description} />
            </div>
          </div>

          <BookingFormSummary
            hasAmonut={false}
          >
            <div className={classNames('button-set')}>
              <Button
                styleType={'secondary'}
                onClick={() => {
                  // console.log(BookingOption)
                  // navigate(URLS.EMAIL_LOGIN)
                  window.open(ojtLink)
                }}
              >기본정보 입력하기</Button>
            </div>
          </BookingFormSummary>
        </div>
      )}
    </>
  )
}

export default CompleteContract;